module.exports = __webpack_public_path__ + "img/bg.93c4f15a.png";